/* unplugin-vue-components disabled */import { render } from "./cdtuQrCodeLink.vue?vue&type=template&id=7460db2a&scoped=true"
import script from "./cdtuQrCodeLink.vue?vue&type=script&lang=js"
export * from "./cdtuQrCodeLink.vue?vue&type=script&lang=js"

import "./cdtuQrCodeLink.vue?vue&type=style&index=0&id=7460db2a&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-成都工业学院-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7460db2a"]])

export default __exports__